import React from 'react'
import Full from './Full'
import InvalidProbe from './InvalidProbe'
import Activity from './Activity'
import CriticalVolume from './CriticalVolume'
import CurrentEventList from './CurrentEventList'
// import EventNumber from './EventNumber'
import { getTrackableIds, getSensorIds } from '../utils/trackable'
import EventCount from './EventCount'
import Grid from '@material-ui/core/Grid'
// import { Query } from 'react-apollo'
import { LATEST_METRIC } from '../query/metric'
import { REFUEL_EVENT, COUNT_CURRENT_EVENT } from '../query/event'
import CircularProgress from '@material-ui/core/CircularProgress'
import { omegaClient } from '../graphql/omegaClient'

class DashboardContentComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      latestMetrics: [],
      refuelEvents: [],
      sensorIds: this.getSensorIds(),
      loading: true
    }
    this.pollingInterval = null
  }
  getSensorIds () {
    return getSensorIds(this.props.trackables)
  }

  getTrackableIds () {
    return getTrackableIds(this.props.trackables)
  }

  latestMetrics (trackableLabels) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: LATEST_METRIC,
          variables: { trackable_labels: trackableLabels },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.latest_metrics)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  refuelEvents (trackableLabels) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: REFUEL_EVENT,
          variables: { trackable_labels: trackableLabels },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.refuel_events)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  fetchData () {
    this.latestMetrics(this.state.sensorIds)
      .then((latestMetrics) => {
        this.setState({
          latestMetrics
        })
      })
      .catch((error) => {
        console.log('error', error)
      })

    this.refuelEvents(this.state.sensorIds)
      .then((refuelEvents) => {
        this.setState({
          refuelEvents,
          loading: false
        })
      })
      .catch((error) => {
        console.log('error', error)
      })
  }

  componentDidMount () {
    // Fetch data immediately
    this.fetchData()

    // Set up polling every 1 minute (60000ms)
    this.pollingInterval = setInterval(() => {
      this.fetchData()
    }, 60000)
  }

  componentWillUnmount () {
    // Clear interval to prevent memory leaks
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
  }

  render () {
    return (
      <div style={styles.root}>
        {this.state.loading ? (
          <CircularProgress style={styles.progressStyle} color='inherit' />
        ) : (
          <Grid container spacing={24}>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Full
                sensorIds={this.state.sensorIds}
                metrics={this.state.latestMetrics}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <CriticalVolume
                sensorIds={this.state.sensorIds}
                metrics={this.state.latestMetrics}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Activity
                sensorIds={this.state.sensorIds}
                metrics={this.state.latestMetrics}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <InvalidProbe
                sensorIds={this.state.sensorIds}
                metrics={this.state.latestMetrics}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <CurrentEventList
                sensorIds={this.state.sensorIds}
                refuelEvents={this.state.refuelEvents}
                trackables={this.props.trackables}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <EventCount
                sensorIds={this.state.sensorIds}
                refuelEvents={this.state.refuelEvents}
              />
            </Grid>

            {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <EventNumber
            title='SONDE SANS INFORMATION'
            number='0'
            label='Depuis 24h'
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <EventNumber
            title='VEHICULE NON CONNECTE'
            number='0'
          />
        </Grid> */}
          </Grid>)}
      </div>
    )
  }
}

const styles = {
  root: {
    flexGrow: 1,
    marginLeft: '14px',
    marginBottom: '20px'
  },
  content: {
    height: '320px'
  },
  paper: {
    textAlign: 'center',
    backgroundColor: 'grey',
    height: '380px'
  },
  progressStyle: {
    color: '#7ED321'
  }
}

export default DashboardContentComponent
